
<div class="row">
    <div class="col-xl-8">
        <mat-card class="card-light" #card>
            <mat-card-header>
                <mat-card-title>{{ 'EMPLOYEE_LIST.EMPLOYEE_LIST' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="responsive-size">
    
                <!-- <mat-list role="list" *ngIf="companies$ | async as items">
                    <mat-list-item role="listitem" *ngFor="let company of items">{{ company.name }}</mat-list-item>
                    </mat-list> -->
    
                    <div class="filter-box">
                        <div class="flex-horizontal">
                            
                                <mat-form-field appearance="outline" class="flex-fill">
                                    <mat-label>{{ 'EMPLOYEE_LIST.SEARCH' | translate }}</mat-label>
                                    <input matInput type="text" [formControl]="searchControl" autocomplete="off">
                                    <button *ngIf="searchControl.value" matSuffix mat-icon-button [attr.aria-label]="'EMPLOYEE_LIST.CLEAR' | translate" (click)="clearText()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-icon matSuffix>search</mat-icon>       
                                </mat-form-field>
                            
                            <div>
                                <div class="view-button-panel">
                                    <span>{{ 'EMPLOYEE_LIST.VIEW' | translate }}</span>
                                    <div>
                                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="viewMode">
                                            <mat-button-toggle value="companyIndependent" [attr.aria-label]="'EMPLOYEE_LIST.COMPANY_INDEPENDENT_SEARCH' | translate" [title]="'EMPLOYEE_LIST.COMPANY_INDEPENDENT_SEARCH' | translate" (click)="viewCompanyIndependent()">
                                            <mat-icon>domain</mat-icon>
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="filter-row">
                            <div class="filter-label">{{ 'EMPLOYEE_LIST.FILTER' | translate }}</div>
                            <mat-checkbox [(ngModel)]="filterExpired" (change)="filterExpiredRp($event)">{{ 'EMPLOYEE_LIST.EXPIRED_DEADLINE' | translate }}</mat-checkbox>
                        </div>
                    </div>
                    
                    <div class="message-panel">{{ searchMessage }}</div>
    
                    <ng-container *ngIf="items$ | async as items">
    
                        <table mat-table [dataSource]="items" matSort
                            class="table-and-card table-hover hover-pointer" multiTemplateDataRows
                            matSortActive="name" matSortDirection="asc"
                            matSortDisableClear
                            (matSortChange)="announceSortChange($event)" >
                                                                
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'EMPLOYEE_LIST.NAME' | translate }}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-16">{{ element.employee.name }}</div>
                                <div class="text-description text-10 sub-text">{{ element.employee.employeeIdentifier ? element.employee.employeeIdentifier + ' | ' : ''}} {{ element.email }}</div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="!isCompanyIndependentMode">{{ 'EMPLOYEE_LIST.COMPANY' | translate }}</th>
                            <td mat-cell *matCellDef="let element" [hidden]="!isCompanyIndependentMode">
                                {{ element.company }}
                            </td>
                        </ng-container>
    <!-- 
                        <ng-container matColumnDef="sziluett" [hidden]="!isAllowSziluettDiagramEdit">
                            
                            <td mat-cell *matCellDef="let element" [hidden]="!isCompanyIndependentMode">
                                Sziluett
                            </td>
                        </ng-container> -->
                        <ng-container matColumnDef="sziluettState">
                            <th mat-header-cell *matHeaderCellDef class="sziluett padding-left-4" [hidden]="!isAllowSziluettDiagramEdit">
                                {{ 'EMPLOYEE_LIST.STATUS' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="sziluett padding-left-4 hover-bk dark-hover-text ch-group1" [hidden]="!isAllowSziluettDiagramEdit">
                                <div class="field-block-title">{{ 'EMPLOYEE_LIST.SZILUETT_STATUS_LABEL' | translate }}</div>
                                {{ element.employee.lastSziluettState | assessmentStatusName }}
                                <span class="empty-val" *ngIf="element.employee.lastSziluettState === null">-</span>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="lastSziluettFinishDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                                class="sziluett"
                                [hidden]="!isAllowSziluettDiagramEdit">                                
                                {{ 'EMPLOYEE_LIST.COMPLETION' | translate }}</th>
                            <td mat-cell *matCellDef="let element" class="sziluett hover-bk dark-hover-text ch-group1" [hidden]="!isAllowSziluettDiagramEdit">
                                <div class="field-block-title">{{ 'EMPLOYEE_LIST.SZILUETT_COMPLETION_LABEL' | translate }}</div>
                                    {{ element.employee.lastSziluettFinishDate | localizedDate }}
                                <span class="empty-val" *ngIf="element.employee.lastSziluettFinishDate === null">-</span>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="isSziluettDiagramAllowed">
                            <th mat-header-cell *matHeaderCellDef class="sziluett" [hidden]="!isAllowSziluettDiagramEdit || isCompanyIndependentMode" [innerHTML]="'EMPLOYEE_LIST.SZILUETT_DIAGRAM_LABEL' | translate"></th>
                            <td mat-cell *matCellDef="let element" class="sziluett hover-bk ch-group1" [hidden]="!isAllowSziluettDiagramEdit || isCompanyIndependentMode">
                                
                                <div *ngxPermissionsOnly="['Assistant']">
                                    <div class="field-block-title" [innerHTML]="'EMPLOYEE_LIST.SZILUETT_DIAGRAM_LABEL' | translate"></div>
                                    {{ element.employee.isSziluettDiagramAllowed !== null ? (element.employee.isSziluettDiagramAllowed ? 'Igen': 'Nem') : '' }}
                                    <span class="empty-val" *ngIf="element.employee.isSziluettDiagramAllowed === null">-</span>
                                </div>
                                <ng-container *ngxPermissionsOnly="['SuperAdmin', 'Admin']">
                                    <div class="field-block-title" [innerHTML]="'EMPLOYEE_LIST.SZILUETT_DIAGRAM_LABEL' | translate"></div>
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? changeAllowSziluettDiagram($event, element.employee) : null"
                                        [checked]="element.employee.isSziluettDiagramAllowed">
                                    </mat-checkbox>
                                </ng-container>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="isOwnPanoramaAuraReportAllowed">
                            <th mat-header-cell *matHeaderCellDef class="panorama" [hidden]="!isAllowPanoramaSettingsEdit || isCompanyIndependentMode" [innerHTML]="'EMPLOYEE_LIST.OWN_PAN_AURA_LABEL' | translate"></th>
                            <td mat-cell *matCellDef="let element" class="panorama hover-bk" [hidden]="!isAllowPanoramaSettingsEdit || isCompanyIndependentMode">
                                
                                <div *ngxPermissionsOnly="['Assistant']">
                                    <div class="field-block-title" [innerHTML]="'EMPLOYEE_LIST.OWN_PAN_AURA_LABEL' | translate"></div>
                                    {{ element.employee.isOwnPanoramaAuraReportAllowed !== null ? (element.employee.isOwnPanoramaAuraReportAllowed ? 'Igen': 'Nem') : '' }}
                                </div>
                                <ng-container *ngxPermissionsOnly="['SuperAdmin', 'Admin']">
                                    <div class="field-block-title" [innerHTML]="'EMPLOYEE_LIST.OWN_PAN_AURA_LABEL' | translate"></div>
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? changeOwnPanoramaAuraReportAllowed($event, element.employee) : null"
                                        [checked]="element.employee.isOwnPanoramaAuraReportAllowed"
                                        *ngIf="element.employee.hasPanoramaAuraRpe">
                                    </mat-checkbox>
                                </ng-container>
                            </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="padding-left-4" [hidden]="!hasElevatedAccess || isCompanyIndependentMode"></th>
                            <td mat-cell *matCellDef="let element" class="padding-left-4 col-actions" [hidden]="!hasElevatedAccess || isCompanyIndependentMode">
                                <button mat-flat-button color="primary" (click)="$event.stopPropagation(); selectEmployee(element)">
                                    <mat-icon class="normal no-margin" [title]="'EMPLOYEE_LIST.SELECT_EMPLOYEE' | translate">add</mat-icon>
                                </button>
                            </td>
                        </ng-container>
    
                        <!-- Header row first group -->
                        <ng-container matColumnDef="header-row-first-group">
                            <th mat-header-cell *matHeaderCellDef                                 
                                [attr.colspan]="firstHeaderGroupColSpan"                                
                                >
                            </th>
                        </ng-container>
    
                        <!-- Header row Sziluett group -->
                        <ng-container matColumnDef="header-row-sziluett-group">
                            <th mat-header-cell *matHeaderCellDef 
                                [style.text-align]="center"
                                class="sziluett"
                                [attr.colspan]="sziluettHeaderGroupColSpan">
                            Sziluett
                            </th>
                        </ng-container>
    
                        <!-- Header row Panorama group -->
                        <ng-container matColumnDef="header-row-panorama-group">
                            <th mat-header-cell *matHeaderCellDef 
                            [hidden]="isCompanyIndependentMode"
                            [style.text-align]="center"
                            class="panorama">
                            Panoráma<br>
                            és Aura
                            </th>
                        </ng-container>
    
                        <ng-container matColumnDef="header-row-action-group">
                            <th mat-header-cell *matHeaderCellDef 
                                [hidden]="!isAllowUserMigration || isCompanyIndependentMode"
                                [style.text-align]="center" >
                            </th>
                        </ng-container>
        
                        <tr mat-header-row *matHeaderRowDef="['header-row-first-group', 'header-row-sziluett-group', 'header-row-panorama-group', 'header-row-action-group']"></tr>
                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr mat-row *matRowDef="let element; columns: tableColumns;"
                            class="element-row"                         
                            [ngClass]="{'selected': element.isSelected, 'no-pointer': !isEmployeeInCurrentCompany(element) }"
                            (click)="onMasterRowClick(element)"
                            ></tr>
                    </table>
                    <mat-paginator #paginator [length]="total"
                                [pageSize]="pageSize"
                                [pageSizeOptions]="pageSizeOptions"
                                (page)="pagingSettingsChanged($event)"
                                [attr.aria-label]="'EMPLOYEE_LIST.CHOOSE_PAGE' | translate">
                    </mat-paginator>
    
                    </ng-container>
    
                    <div class="action-buttons">
                        <button mat-flat-button color="primary" (click)="addEmployee()">
                            <mat-icon>add</mat-icon>
                            {{ 'EMPLOYEE_LIST.NEW_EMPLOYEE' | translate }}
                        </button>
                    </div>
    
            </mat-card-content>
        </mat-card>
    </div>
    
    <div class="col-xl-4" *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
        <mat-card class="card-light" *ngIf="!isCompanyIndependentMode">
            <mat-card-header>
                <mat-card-title>{{ 'EMPLOYEE_LIST.BATCH_OPERATIONS' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
    
                <div class="flex-horizontal gap-10">
                    <div class="fields flex1">
                        <mat-form-field appearance="outline" class="flex1 full-width">
                            <mat-label>{{ 'EMPLOYEE_LIST.OPERATION' | translate }}</mat-label>
                            <mat-select [(value)]="selectedAction" disableOptionCentering class="drop-fix" (selectionChange)="actionChanged()">
                                <mat-option *ngFor="let item of actionList" [value]="item">{{ item.nameKey | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline" class="flex1 full-width" *ngIf="selectedAction && selectedAction.id === 1">
                            <mat-label>{{ 'EMPLOYEE_LIST.COMPANY_MIGRATION_TARGET' | translate }}</mat-label>
                            <mat-select [(value)]="selectedCompany" disableOptionCentering class="drop-fix">
                                <mat-option *ngFor="let item of companyList" [value]="item.id">{{ item.name }}</mat-option>
                            </mat-select>       
                        </mat-form-field>
                    </div>
                    <div class="flex1 text-16 desc-panel">                    
                        <ng-container *ngIf="selectedAction">
                            <div *ngIf="selectedAction.id == 1">
                                <p>{{ selectedAction.descriptionKey | translate }}</p>
                            </div>
                            <div *ngIf="selectedAction.id == 2" class="text-14">
                                <p>{{ 'TEXTS.DELETE_EMPLOYEE_BATCH_LINE1' | translate }}</p>
                                <p class="text-danger">{{ 'TEXTS.DELETE_EMPLOYEE_BATCH_LINE2' | translate }}</p>
                                <p>{{ 'TEXTS.DELETE_EMPLOYEE_BATCH_LINE3' | translate }}</p>
                                <p>{{ 'TEXTS.DELETE_EMPLOYEE_BATCH_LINE4' | translate }}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
        
                <h5>{{ 'EMPLOYEE_LIST.SELECTED_EMPLOYEES' | translate }}</h5>
                <div class="scroll-panel" *ngIf="basket.obs$ | async as basketItems">
                    <app-dynamic-list-item 
                        (delete)="unselectEmployee(item.itemSource.employee.id)"
                        [actionState]="listState" 
                        [noEdit]="true"
                        *ngFor="let item of basketItems; index as i" [index]="i" [source]="item">
                        <div slot="readonly" class="flex-horizontal">
                            <div class="field-index"></div>
                            <div class="field-text"><span class="name">{{ item.itemSource.employee.name }}</span><span class="email"> ({{ item.itemSource.email }})</span></div>
                            <div class="field-id">{{ item.itemSource.employee.employeeIdentifier ?? '' }}</div>
                        </div>
                    </app-dynamic-list-item>
                    <div *ngIf="!basket.value || basket.value.length === 0">{{ 'EMPLOYEE_LIST.NO_SELECTED_EMPLOYEE' | translate }}</div>
                </div>
    
                <button mat-flat-button color="primary" (click)="startAction()" [disabled]="!isStartEnabled">
                    <mat-icon>play_arrow</mat-icon>
                    {{ 'EMPLOYEE_LIST.START' | translate }}
                </button>
            </mat-card-content>
        </mat-card>
    </div>
</div>
